// extracted by mini-css-extract-plugin
export default {"forgetPassword":"ForgerPassword_forgetPassword__MBV1k","forgetPassword__container":"ForgerPassword_forgetPassword__container__TIMJv"};